import React, { forwardRef, useImperativeHandle } from "react";

const Predictions = forwardRef((prop, ref) => {
  let classifier;
  preLoad();

  function preLoad() {
    // eslint-disable-next-line no-undef
    classifier = ml5.imageClassifier(
      "https://teachablemachine.withgoogle.com/models/KR0Vp38ym/model.json",
      modelLoaded
    );
  }

  function modelLoaded() {
    console.log("Model Loaded!");
  }
  function getResults(resPredcition) {
    var res;
    let random = prop.random;
    // console.log("randomNum", random);
    let predictNum =
      resPredcition === "rock" ? 1 : resPredcition === "paper" ? 2 : 3;
    // console.log("predictedNum", predictNum);
    if (random === predictNum) {
      res = "Tie!";
    } else if (predictNum === 1) {
      if (random === 2) {
        res = "You lose!, Paper covers Rock";
        prop.updateComputerScore();
      } else {
        res = "You win!, Rock smashes Scissor";
        prop.updatePlayerScore();
      }
    } else if (predictNum === 2) {
      if (random === 3) {
        res = "You lose!, Scissor cuts Paper";
        prop.updateComputerScore();
      } else {
        res = "You win!, Paper covers Rock";
        prop.updatePlayerScore();
      }
    } else if (predictNum === 3) {
      if (random === 1) {
        res = "You lose!, Rock smashes Scissor";
        prop.updateComputerScore();
      } else {
        res = "You win!, Scissor cuts Paper";
        prop.updatePlayerScore();
      }
    }
    prop.updateResult(res);
  }
  useImperativeHandle(ref, () => ({
    detectImage() {
      classifier.classify(document.getElementById("Imgcap"), (err, results) => {
        if (err) {
          console.error(err);
          return;
        }
        // console.log("Confidence : ", JSON.stringify(results));
        // console.log("Predicted is :", results[0].label);
        let resPredcition = results[0].label;
        prop.updatePredict(results[0].label);
        getResults(resPredcition);
      });
    },
  }));

  return (
    <div id="label-container">
      <h1>{prop.prediction}</h1>
      <h1>{prop.result}</h1>
    </div>
  );
});

export default Predictions;
